const STRIPE_PUBLISH_KEY = 'pk_live_qY3OVz0Fgo95r5UL6COIkP4Y';
// const STRIPE_PUBLISH_KEY = 'pk_test_7oKpkFYOepiF0KzqGiHsZ4va';
const INSTA_ACCESSTOKEN = 'IGAASwVZAYKC1hBZAE5HMzNPcS0zQnpBTjg5SWhUTkRtNlpsa0JDWGFfVFZAlS0tnRnJNcVJSXzBLUWYxa1dycE9sd0t1Y1ZA2b014c2UxVElSRHRyNjRZALUZA4XzJ4N0JsSG1fWEdLNU9RNGw0cHF3U0JzQ1RqZAk0zSi10c3dkOTZAMcwZDZD'
const PAYPAL_CLIENT_ID = 'AeLZdVVYErQtCdA3XcV78ZNtY4xddRgnyrebVh_zBj32rnEVTH7uGd3OixnMwiBRp3AcxcVx9c0mvX7z'
export {
    STRIPE_PUBLISH_KEY,
    INSTA_ACCESSTOKEN,
    PAYPAL_CLIENT_ID
}